var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React from 'react';
import { node, string } from 'prop-types';
import styled from 'styled-components';
var ellipsisPath = "M1.85,10.78A6.12,6.12,0,0,1,0,6.31,6.09,6.09,0,0,1,1.85,1.85,6.09,6.09,0,0,1,6.31,0a6.12,6.12,0,0,1,4.47,1.85,6.08,6.08,0,0,1,1.84,4.46,6.12,6.12,0,0,1-1.84,4.47,6.12,6.12,0,0,1-4.47,1.84A6.08,6.08,0,0,1,1.85,10.78Zm18.94,0a6.09,6.09,0,0,1-1.85-4.47,6,6,0,0,1,1.85-4.46,6.3,6.3,0,0,1,8.92,0,6,6,0,0,1,1.85,4.46,6.09,6.09,0,0,1-1.85,4.47,6.33,6.33,0,0,1-8.92,0Zm18.93,0a6.12,6.12,0,0,1-1.84-4.47,6.08,6.08,0,0,1,1.84-4.46,6.31,6.31,0,0,1,8.93,0A6.09,6.09,0,0,1,50.5,6.31a6.12,6.12,0,0,1-1.85,4.47,6.34,6.34,0,0,1-8.93,0Z";
var ellipsisViewbox = "0 -34 51 20";
var checkmarkPath = "M49.68,9.07,19.51,39.27a1.37,1.37,0,0,1-.75.29,1.4,1.4,0,0,1-.76-.29L.32,21.56A1,1,0,0,1,0,20.82a1,1,0,0,1,.32-.75l7.29-7.29a1,1,0,0,1,.74-.29,1.05,1.05,0,0,1,.75.29l9.66,9.71L40.9.29A1,1,0,0,1,41.65,0a1,1,0,0,1,.74.29l7.29,7.3a1,1,0,0,1,0,1.48Z";
var checkmarkViewbox = "0 -34 50 48";
var ListItem = styled.li(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  list-style-image: ", ";\n  padding: 0 2.5rem 0 1.1rem;\n  font-size: 16px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.75;\n  letter-spacing: normal;\n  color: #42484d;\n  max-width: 15rem;\n"])), function (props) {
  return "url(".concat(props.icon, ")");
});
ListItem.displayName = 'ListItem';

var CheckListItem = function CheckListItem(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? 'checkmark' : _ref$iconName;
  var iconPath = iconName === 'checkmark' ? checkmarkPath : ellipsisPath;
  var iconViewbox = iconName === 'ellipsis' ? ellipsisViewbox : checkmarkViewbox;
  var getpath = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='".concat(iconViewbox, "' fill='rgb(69, 165, 124)' height='28px' width='14px'%3E%3Cpath d='").concat(iconPath, "'/%3E%3C/svg%3E\"");
  return /*#__PURE__*/React.createElement(ListItem, {
    key: children,
    icon: getpath,
    className: "scl-card-text ".concat(className),
    "data-test-id": "scl-card-text"
  }, children);
};

CheckListItem.propTypes = {
  /**
   Optional className to include in rendered component
  */
  className: string,

  /**
   Required and consists of everything between opening and closing tags
  */
  children: node.isRequired,

  /**
   Optional to change the icon used as a list item image. Defaults to a check mark.
  */
  iconName: string
};
export default CheckListItem;